import React, { useEffect, useState } from "react";
import { Wrench } from "@phosphor-icons/react";
import api from "@/lib/api";

const DEFAULT_MSG = "We're doing scheduled maintenance. Some features may be briefly unavailable — please check back shortly.";

// Site-wide maintenance banner. Owner toggles it from Command Center → Platform Settings.
// Reads the PUBLIC settings (no auth), so every visitor sees it when active.
export const MaintenanceBanner = () => {
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = () => api.get("/settings/public").then(({ data }) => { if (alive) setCfg(data || {}); }).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  if (!cfg?.maintenance_enabled) return null;
  const msg = (cfg.maintenance_message || "").trim() || DEFAULT_MSG;

  return (
    <div
      data-testid="maintenance-banner"
      role="status"
      className="sticky top-0 z-[60] flex items-center justify-center gap-2.5 px-4 py-2.5 text-center text-sm font-semibold text-white"
      style={{ background: "linear-gradient(90deg,#B45309,#F59E0B,#B45309)", boxShadow: "0 2px 12px rgba(0,0,0,0.25)" }}
    >
      <Wrench size={18} weight="fill" className="shrink-0" />
      <span data-testid="maintenance-message" className="leading-snug">{msg}</span>
    </div>
  );
};

export default MaintenanceBanner;
